module.exports = __webpack_public_path__ + "static/media/logo-mha.7260a722.svg";